import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { calculateCFT } from "../services/cftService";
import { getWoodTypes } from "../services/woodTypeService";
import "./CalculateCFTLayer.css";
const CalculateCFTLayer = () => {
  const [form, setForm] = useState({
    wood_type: "",
    length_in: "",
    width_in: "",
    thickness_in: "",
    qty: "",
  });

  const [woodTypes, setWoodTypes] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // -----------------------------
  // LOAD WOOD TYPES
  // -----------------------------
  useEffect(() => {
    loadWoodTypes();
  }, []);

  const loadWoodTypes = async () => {
    try {
      const res = await getWoodTypes();
      console.log("WOOD TYPES API:", res);

      if (res?.status === "success") {
        setWoodTypes(res.data || []);
      } else {
        toast.error(res?.message || "Failed to load wood types");
      }
    } catch (err) {
      console.error(err);
      toast.error("API Error while loading wood types");
    }
  };

  // -----------------------------
  // HANDLE CHANGE
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // -----------------------------
  // VALIDATION
  // -----------------------------
  const validateForm = () => {
    if (!form.wood_type) return "Wood type required";
    if (!form.length_in) return "Length required";
    if (!form.width_in) return "Width required";
    if (!form.thickness_in) return "Thickness required";
    if (!form.qty) return "Quantity required";
    return null;
  };

  // -----------------------------
  // SUBMIT
  // -----------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validateForm();
    if (error) {
      toast.error(error);
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const res = await calculateCFT(form);

      if (res?.status === "success") {
        setResult(res.data);
        toast.success(res.message);
      } else {
        toast.error(res?.message || "Calculation failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("API Error");
    }

    setLoading(false);
  };

return (
  <div className="cft-container">
    <div className="cft-card">
      <h4 className="cft-title">CFT Calculator</h4>

      <form onSubmit={handleSubmit} className="cft-form">

        <div className="cft-group">
          <label>Wood Type *</label>
          <select
            name="wood_type"
            value={form.wood_type}
            onChange={handleChange}
          >
            <option value="">Select Wood Type</option>
            {woodTypes.map((w) => (
              <option key={w.id} value={w.wood_type}>
                {w.wood_type}
              </option>
            ))}
          </select>
        </div>

        <div className="cft-group">
          <label>Length (inch)</label>
          <input
            type="number"
            name="length_in"
            value={form.length_in}
            onChange={handleChange}
          />
        </div>

        <div className="cft-group">
          <label>Width (inch)</label>
          <input
            type="number"
            name="width_in"
            value={form.width_in}
            onChange={handleChange}
          />
        </div>

        <div className="cft-group">
          <label>Thickness (inch)</label>
          <input
            type="number"
            name="thickness_in"
            value={form.thickness_in}
            onChange={handleChange}
          />
        </div>

        <div className="cft-group">
          <label>Quantity</label>
          <input
            type="number"
            name="qty"
            value={form.qty}
            onChange={handleChange}
          />
        </div>

        <div className="cft-submit">
          <button type="submit" disabled={loading}>
            {loading ? "Calculating..." : "Calculate CFT"}
          </button>
        </div>
      </form>

      {result && (
        <div className="cft-result">
          <p><b>Wood Type:</b> {result.wood_type}</p>
          <p><b>CFT per Piece:</b> {Number(result.cft_per_piece).toFixed(4)}</p>
          <p><b>Total CFT:</b> {Number(result.total_input_cft).toFixed(4)}</p>
        </div>
      )}
    </div>
  </div>
);

};

export default CalculateCFTLayer;
